import React from 'react';

const LookupIcon = () => {
  return (
    <svg
      width='11'
      height='14'
      viewBox='0 0 11 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 14C0 12.5855 0.561903 11.229 1.5621 10.2288C2.56229 9.22857 3.91885 8.66667 5.33333 8.66667C6.74782 8.66667 8.10438 9.22857 9.10457 10.2288C10.1048 11.229 10.6667 12.5855 10.6667 14H9.33333C9.33333 12.9391 8.91191 11.9217 8.16176 11.1716C7.41162 10.4214 6.3942 10 5.33333 10C4.27247 10 3.25505 10.4214 2.50491 11.1716C1.75476 11.9217 1.33333 12.9391 1.33333 14H0ZM5.33333 8C3.12333 8 1.33333 6.21 1.33333 4C1.33333 1.79 3.12333 0 5.33333 0C7.54333 0 9.33333 1.79 9.33333 4C9.33333 6.21 7.54333 8 5.33333 8ZM5.33333 6.66667C6.80667 6.66667 8 5.47333 8 4C8 2.52667 6.80667 1.33333 5.33333 1.33333C3.86 1.33333 2.66667 2.52667 2.66667 4C2.66667 5.47333 3.86 6.66667 5.33333 6.66667Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default LookupIcon;
